/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toolcardremoved2Inputs */

const en_toolcardremoved2 = /** @type {(inputs: Toolcardremoved2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🗑 removed`)
};

const pt_toolcardremoved2 = /** @type {(inputs: Toolcardremoved2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🗑 removido`)
};

/**
* | output |
* | --- |
* | "🗑 removed" |
*
* @param {Toolcardremoved2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const toolcardremoved2 = /** @type {((inputs?: Toolcardremoved2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toolcardremoved2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_toolcardremoved2(inputs)
	return pt_toolcardremoved2(inputs)
});
export { toolcardremoved2 as "toolCardRemoved" }